module.exports = "/images/vendor/desiigner-svg/svg/apple-pay.svg?41975515ff6ad0f6def406cf00ed8b69";